import React from 'react';
import banner from '../../banner.jpg';
const Header = () => {
    return (
        <div className='px-4 w-10/12 mx-auto grid sm:grid-cols-1 md:grid-cols-2 gap-4 py-2'>
            <div className='md:text-left my-auto text-4xl font-bold text-slate-800 text-center py-14 md:py-0 '>
                <h2 className='font-extrabold '>Let's play</h2>
                <p className='text-xl my-4'>Test your knowledge with us. And boost your brain.</p>
            </div>
            
            <div>
                <img className='rounded' src={banner} alt="" />
            </div>
        </div>
    );
};

export default Header;